import {ConsultProtocolsItem} from 'domain/usecases/private/consult-protocols/get-consult-protocols';

type ProtocolStatusDrawerProps = {
	openDrawer: boolean;
	onOpenDrawer: () => void;
	onCloseDrawer: () => void;
	protocol: ConsultProtocolsItem;
};

export enum TrackRefundStatusEnum {
	APPROVED = 'Reembolso Aprovado',
	PROCESSED = 'Pagamento Processado',
	DENIED = 'Reembolso Indeferido',
}

export type {ProtocolStatusDrawerProps};
